<script>
import Menu from 'ant-design-vue/es/menu';
import 'ant-design-vue/es/menu/style';

export default {
  name: 'MMenu',
  extends: Menu
};
</script>
